
var sprite = require("C:/git/annenberg-petspace-petbook/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 359.5 633.79\" id=\"circle-template-right\" ><title>Asset 6</title><g data-name=\"Layer 2\"><path d=\"M0 0c175 0 316.89 141.88 316.89 316.89S175 633.79 0 633.79h359.5V0z\" data-name=\"Layer 1\"/></g></symbol>";
module.exports = sprite.add(image, "circle-template-right");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/circle-template-right.svg
// module id = 302
// module chunks = 1